import { PeriodType } from '../../../widget/date-range.widget.model';

export interface InsightsSummaryDataPeriodTypes {
    periodTypeId?: number;
    periodTypeName?: string;
    periodTypeDate?: Date;
    displayOrder?: number;
    isDefault?: boolean;
}

export function defaultInsightsSummaryDataPeriodTypes(): InsightsSummaryDataPeriodTypes {
    return {
        periodTypeId: PeriodType.ROLLING_30,
        periodTypeDate: new Date(),
    };
}
